export default __webpack_public_path__ + "static/media/paytm-logo-purple.576044db.svg";